import React, { FunctionComponent } from 'react';
import gql from 'graphql-tag';
import { calendarIcon, inMemoryIcon, teamIcon } from '@justgiving/icons';
import IconType from '../../constants/iconTypes';
import './Reason.scss';
import {
  ReasonFragment,
  Reason as ReasonType,
} from '../../../types/__generated__';
import usePageQuery, {
  buildQuery,
  UsePageQueryResult,
} from '../../hooks/usePageQuery';
import IconLabel from '../IconLabel/IconLabel';

const FRAGMENT = buildQuery(gql`
  fragment Reason on Page {
    reason {
      icon
      reason
      reasonUrl
    }
  }
`);

function renderReason(reason: ReasonType): string | JSX.Element {
  if (!reason.reasonUrl) {
    return reason.reason ?? '';
  }

  return <a href={reason.reasonUrl}>{reason.reason}</a>;
}

const iconMap = {
  [IconType.CalendarIcon]: calendarIcon,
  [IconType.InMemoryIcon]: inMemoryIcon,
  [IconType.TeamIcon]: teamIcon,
};

export const Reason: FunctionComponent = () => {
  const result = usePageQuery<ReasonFragment>(FRAGMENT);
  if (!UsePageQueryResult.hasData(result) || !result.data.reason) {
    return null;
  }
  const reason = result.data.reason;
  const icon = reason.icon ? iconMap[reason.icon] : '';

  return (
    <div data-qa="reason-details">
      <IconLabel icon={icon} label={renderReason(reason)} />
    </div>
  );
};

export default Reason;
